<template>
  <div class="animated fadeIn">
    <!-- <div class="title font-300 font-24 mb-15">Form Weekly Log</div> -->
    <div class="box">
      <div class="p-20 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="
              openPage(
                '/memberData/detail?id=' +
                id_lead_member +
                '&id_lead=' +
                id_lead
              )
              " class="link-back"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-20 pt-0">
        <form @submit.prevent="submitForm">
          <div class="row mb-30">
            <div class="col-lg-6">
              <div class="font-bold mt-20" style="font-size: 18px;">Basic Information</div>
              <hr class="short-line left" />
              <hr>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Personal Trainer</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select :disabled="true" name="refferal_pt_id" v-model="addData.personal_trainer_id"
                    class="form-control border-bottom">
                    <option value="null">Please select</option>
                    <option v-for="item in itemsPT" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Body Composition Progress</div>
              <hr class="short-line left" />

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Current Body Weight?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.current_body_weight" name="current_body_weight" type="text"></b-form-input>
                  <span class="error">{{ errors.first("current_body_weight") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Change From Start: Body Weight?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.body_weight_change"
                    id="body_weight_change" name="body_weight_change">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("body_weight_change") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.body_weight_change_remarks"
                    name="body_weight_change_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("body_weight_change_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Fat%<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom" v-model="addData.body_fat"
                    name="body_fat" type="text"></b-form-input>
                  <span class="error">{{ errors.first("body_fat") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Muscle%<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom" v-model="addData.body_muscle"
                    name="body_muscle" type="text"></b-form-input>
                  <span class="error">{{ errors.first("body_muscle") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="mb-2">Upload the Last Visbody/Inbody/Anovator measurement</div>
                </b-col>
                <b-col sm="9">
                  <div class="upload-container">
                    <label class="upload-box" id="drop-area">
                      <input type="file" id="fileElem" hidden accept="image/jpeg,image/png,image/jpg"
                        @change="visbodyImagePreview" />

                      <div class="upload-content">
                        <div class="icon">
                          ☁️
                        </div>
                        <h5>Browse Files</h5>
                        <p>Drag and drop files here</p>
                      </div>
                    </label>

                    <small class="note">
                      Make sure it shows Body Height, Body Weight, Body Fat, Body Fat %, Muscle %, Visceral Fat <br>
                      Format: jpg, jpeg, png | Max Size: 1MB
                    </small>
                    <div class="card" v-if="addData.visbody_photo">
                      <div class="card-body d-flex align-items-center justify-content-start gap-2">
                        <img style="max-width: 10%;" :src="addData.visbody_photo"
                          class="rounded float-start img-responsive w-100" />
                        <span style="padding-left: 10px;" class="font-bold ps-5">Visbody Photo</span>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Current Waist?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.current_waist" name="current_waist" type="text"></b-form-input>
                  <span class="error">{{ errors.first("current_waist") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Change From Start: Waist?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.change_waist" id="change_waist"
                    name="change_waist">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("change_waist") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.current_waist_remarks"
                    name="current_waist_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("current_waist_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="mb-2">Progress FRONT photo<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <div class="upload-container">
                    <label class="upload-box" id="drop-area">
                      <input type="file" id="fileElem" hidden accept="image/jpeg,image/png,image/jpg"
                        @change="frontPhotoPreview" />

                      <div class="upload-content">
                        <div class="icon">
                          ☁️
                        </div>
                        <h5>Browse Files</h5>
                        <p>Drag and drop files here</p>
                      </div>
                    </label>

                    <small class="note">
                      Format: jpg, jpeg, png | Max Size: 1MB
                    </small>

                    <div class="card" v-if="addData.progress_front_photo">
                      <div class="card-body d-flex align-items-center justify-content-start gap-2">
                        <img style="max-width: 10%;" :src="addData.progress_front_photo"
                          class="rounded float-start img-responsive w-100" />
                        <span style="padding-left: 10px;" class="font-bold ps-5">Front Photo</span>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="mb-2">Progress SIDE LEFT photo<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <div class="upload-container">
                    <label class="upload-box" id="drop-area">
                      <input type="file" id="fileElem" hidden accept="image/jpeg,image/png,image/jpg"
                        @change="sideLeftPhotoPreview" />

                      <div class="upload-content">
                        <div class="icon">
                          ☁️
                        </div>
                        <h5>Browse Files</h5>
                        <p>Drag and drop files here</p>
                      </div>
                    </label>

                    <small class="note">
                      Format: jpg, jpeg, png | Max Size: 1MB
                    </small>

                    <div class="card" v-if="addData.progress_side_left_photo">
                      <div class="card-body d-flex align-items-center justify-content-start gap-2">
                        <img style="max-width: 10%;" :src="addData.progress_side_left_photo"
                          class="rounded float-start img-responsive w-100" />
                        <span style="padding-left: 10px;" class="font-bold ps-5">Side Left Photo</span>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="mb-2">Progress SIDE Right photo<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <div class="upload-container">
                    <label class="upload-box" id="drop-area">
                      <input type="file" id="fileElem" hidden accept="image/jpeg,image/png,image/jpg"
                        @change="sideRightPhotoPreview" />

                      <div class="upload-content">
                        <div class="icon">
                          ☁️
                        </div>
                        <h5>Browse Files</h5>
                        <p>Drag and drop files here</p>
                      </div>
                    </label>

                    <small class="note">
                      Make sure it shows Body Height, Body Weight, Body Fat, Body Fat %, Muscle %, Visceral Fat <br>
                      Format: jpg, jpeg, png | Max Size: 1MB
                    </small>
                    <div class="card" v-if="addData.progress_side_right_photo">
                      <div class="card-body d-flex align-items-center justify-content-start gap-2">
                        <img style="max-width: 10%;" :src="addData.progress_side_right_photo"
                          class="rounded float-start img-responsive w-100" />
                        <span style="padding-left: 10px;" class="font-bold ps-5">Side Right Photo</span>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="mb-2">Progress BACK photo<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <div class="upload-container">
                    <label class="upload-box" id="drop-area">
                      <input type="file" id="fileElem" hidden accept="image/jpeg,image/png,image/jpg"
                        @change="sideBackPhotoPreview" />

                      <div class="upload-content">
                        <div class="icon">
                          ☁️
                        </div>
                        <h5>Browse Files</h5>
                        <p>Drag and drop files here</p>
                      </div>
                    </label>

                    <small class="note">
                      Format: jpg, jpeg, png | Max Size: 1MB
                    </small>
                    <div class="card" v-if="addData.progress_side_back_photo">
                      <div class="card-body d-flex align-items-center justify-content-start gap-2">
                        <img style="max-width: 10%;" :src="addData.progress_side_back_photo"
                          class="rounded float-start img-responsive w-100" />
                        <span style="padding-left: 10px;" class="font-bold ps-5">Side Back Photo</span>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Training Progress</div>
              <hr class="short-line left" />
              <hr>


              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Strength Improvement<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.strength_improvement"
                    id="strength_improvement" name="strength_improvement">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("strength_improvement") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.strength_improvement_remarks"
                    name="strength_improvement_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("strength_improvement_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Carry Improvement<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.carry_improvement" id="carry_improvement"
                    name="carry_improvement">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("carry_improvement") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.carry_improvement_remarks"
                    name="carry_improvement_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("carry_improvement_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Conditioning Improvement<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.conditioning_improvement"
                    id="conditioning_improvement" name="conditioning_improvement">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("conditioning_improvement") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.conditioning_improvement_remarks"
                    name="conditioning_improvement_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("conditioning_improvement_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Movement quality Improvement<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.movement_quality_improvement"
                    id="movement_quality_improvement" name="movement_quality_improvement">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("movement_quality_improvement") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom"
                    v-model="addData.movement_quality_improvement_remarks" name="movement_quality_improvement_remarks"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first("movement_quality_improvement_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Confidence in Training<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.confidence_in_training"
                    id="confidence_in_training" name="confidence_in_training">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("confidence_in_training") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.confidence_in_training_remarks"
                    name="confidence_in_training_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("confidence_in_training_remarks") }}</span>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Nutrition Review</div>
              <hr class="short-line left" />
              <hr>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Protein quality / intake consistency<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.protein_quality_intake"
                    id="protein_quality_intake" name="protein_quality_intake">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("protein_quality_intake") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.protein_quality_intake_remarks"
                    name="protein_quality_intake_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("protein_quality_intake_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Hydration consistency<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.hydration_consistency"
                    id="hydration_consistency" name="hydration_consistency">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("hydration_consistency") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.hydration_consistency_remarks"
                    name="hydration_consistency_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("hydration_consistency_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Meal Structure<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.meal_structure" id="meal_structure"
                    name="meal_structure">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("meal_structure") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.meal_structure_remarks"
                    name="meal_structure_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("meal_structure_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Appetite Management<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.appetite_management" id="meal_structure"
                    name="appetite_management">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("appetite_management") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.appetite_management_remarks"
                    name="appetite_management_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("appetite_management_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Weekend Control<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.weekend_control" id="weekend_control"
                    name="weekend_control">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("weekend_control") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.weekend_control_remarks"
                    name="weekend_control_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("weekend_control_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Overall Compliance<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.overall_compliance"
                    id="overall_compliance" name="overall_compliance">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("overall_compliance") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.overall_compliance_remarks"
                    name="overall_compliance_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("overall_compliance_remarks") }}</span>
                </b-col>
              </b-row>

            </div>

            <!-- Col 2 -->
            <div class="col-lg-6">
              <div class="font-bold mt-20" style="font-size: 18px;">Lifestyle Review</div>
              <hr class="short-line left" />
              <hr>

              <!-- Sleep Quality? -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Sleep Quality?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.sleep_quality" id="sleep_quality"
                    name="sleep_quality">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("sleep_quality") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.sleep_quality_remarks"
                    name="sleep_quality_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("sleep_quality_remarks") }}</span>
                </b-col>
              </b-row>

              <!-- Stress Level? -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Stress Management?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.stress_management" id="stress_management"
                    name="stress_management">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("stress_management") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.stress_management_remarks"
                    name="stress_management_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("stress_management_remarks") }}</span>
                </b-col>
              </b-row>

              <!-- Stress Level? -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Daily Movement?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.daily_movement" id="daily_movement" name="daily_movement">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("daily_movement") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.daily_movement_remarks"
                    name="daily_movement_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("daily_movement_remarks") }}</span>
                </b-col>
              </b-row>

              <!-- Stress Level? -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Routine Stability?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.routine_stability" id="routine_stability"
                    name="routine_stability">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("routine_stability") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.routine_stability_remarks"
                    name="routine_stability_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("daily_movement_remarks") }}</span>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Mindset and Accountability</div>
              <hr class="short-line left" />
              <hr>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Ownership<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.mindset_and_accountability" id="mindset_and_accountability"
                    name="mindset_and_accountability">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("mindset_and_accountability") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.mindset_and_accountability_remarks"
                    name="mindset_and_accountability_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("mindset_and_accountability_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Consistency Level<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.consistency_level" id="consistency_level"
                    name="consistency_level">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("consistency_level") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.consistency_level_remarks"
                    name="consistency_level_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("consistency_level_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Confidence Level<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.confidence_level" id="confidence_level" name="confidence_level">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("confidence_level") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.confidence_level_remarks"
                    name="confidence_level_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("confidence_level_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Response to setbacks<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.response_to_setbacks" id="response_to_setbacks"
                    name="response_to_setbacks">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("response_to_setbacks") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.response_to_setbacks_remarks"
                    name="response_to_setbacks_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("response_to_setbacks_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Standard of Effort<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.standart_of_effort" id="standart_of_effort"
                    name="standart_of_effort">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("standart_of_effort") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.standart_of_effort_remarks"
                    name="standart_of_effort_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("standart_of_effort_remarks") }}</span>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Coach Summary</div>
              <hr class="short-line left" />
              <hr>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Biggest Win<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom" v-model="addData.biggest_win"
                    name="biggest_win" type="text"></b-form-input>
                  <span class="error">{{ errors.first("biggest_win") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Biggest Weakness<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.biggest_weakness" name="biggest_weakness" type="text"></b-form-input>
                  <span class="error">{{ errors.first("biggest_weakness") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Main adjustment needed<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.main_adjustment_needed" name="main_adjustment_needed" type="text"></b-form-input>
                  <span class="error">{{ errors.first("main_adjustment_needed") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Recommended focus next phase<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.recommended_focus" name="recommended_focus" type="text"></b-form-input>
                  <span class="error">{{ errors.first("recommended_focus") }}</span>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Blood Test</div>
              <hr class="short-line left" />
              <hr>

              <!-- Fasting Blood Sugar -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Fasting Blood Sugar</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom"
                    v-model="addData.fasting_blood_sugar" name="fasting_blood_sugar" type="number"></b-form-input>
                  <small class="note">
                    Preference: Under 87
                  </small>
                </b-col>
              </b-row>

              <!-- Triglycerides -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Triglycerides</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom"
                    v-model="addData.triglycerides" name="triglycerides" type="number"></b-form-input>
                  <small class="note">
                    Preference: Under 140
                  </small>
                </b-col>
              </b-row>

              <!-- Cholesterol -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Cholesterol</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom" v-model="addData.cholesterol"
                    name="cholesterol" type="number"></b-form-input>
                  <small class="note">
                    Preference: Under 200
                  </small>
                </b-col>
              </b-row>

              <!-- LDL -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>LDL</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom" v-model="addData.ldl"
                    name="ldl" type="number"></b-form-input>
                  <small class="note">
                    Preference: Under 100
                  </small>
                </b-col>
              </b-row>

              <!-- HDL -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>HDL</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom" v-model="addData.hdl"
                    name="hdl" type="number"></b-form-input>
                </b-col>
              </b-row>


              <!-- SGPT (Pancreas Function) -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>SGPT (Liver Function)</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom" v-model="addData.sgpt"
                    name="sgpt" type="number"></b-form-input>
                  <small class="note">
                    Preference: Under 50
                  </small>
                </b-col>
              </b-row>

              <!-- Additional Notes -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Additional Notes</div>
                </b-col>
                <b-col sm="9">
                  <textarea class="form-control border-bottom" name="additional_notes"
                    v-model="addData.additional_notes" id="additional_notes" cols="30"></textarea>
                </b-col>
              </b-row>

              <div class="container py-5">
                <div class="p-4 card-custom">

                  <h3 class="text-center fw-bold mb-4">NUTRITION ADVICE</h3>

                  <p class="fw-semibold text-uppercase text-center mb-4">
                    If your blood test shows high on blood sugar, triglycerides, and cholesterol
                  </p>

                  <!-- DOs -->
                  <h5 class="section-title mb-3">DOs:</h5>

                  <div class="mb-4">
                    <h6 class="fw-bold">1. Recommended Good Fat:</h6>
                    <ul>
                      <li>Avocado</li>
                      <li>Egg</li>
                      <li>Nuts</li>
                      <li>Dark Chocolate</li>
                    </ul>
                    <p class="note">
                      Good fat helps to stabilize hormones and decrease inflammation to the body
                    </p>
                  </div>

                  <div class="mb-4">
                    <h6 class="fw-bold">2. Optimize Gut Function:</h6>
                    <ul>
                      <li>Consume gut drinks: Probiotic, Apple Cider Vinegar, Glutamin, Lemon</li>
                    </ul>
                    <p class="note">
                      Help absorb maximum nutrition, support recovery, so not only depends on medication
                    </p>
                  </div>

                  <div class="mb-4">
                    <h6 class="fw-bold">3. Reduce Inflammation and Stress on the Body:</h6>
                    <ul>
                      <li>Consume support with vitamin: Vit D, Vit C, and Fish Oil</li>
                      <li>(Optional) Consume Berberine</li>
                    </ul>
                    <p class="note">
                      The less stress and inflammation the body = faster recovery
                    </p>
                  </div>

                  <!-- DON'Ts -->
                  <h5 class="section-title mt-4 mb-3">DON'Ts:</h5>

                  <ol>
                    <li>Consume processed food and high sugar drinks (soda, boba, alcohol, high sugar coffee)</li>
                    <li>Drink too much cold pressed juice</li>
                    <li>Too much anaerobic exercise</li>
                    <li>Lack of sleep</li>
                  </ol>

                  <!-- Additional Note -->
                  <h5 class="section-title mt-4 mb-3">Additional Note:</h5>

                  <p class="fw-bold">SGPT (Liver Function)</p>
                  <ul>
                    <li>Impact from daily habit/lifestyle</li>
                    <li>If liver not working well, the blood sugar can increase and cause insulin resistant</li>
                    <li>If absorb nutrition from liver not optimal, make cholesterol in the blood become high</li>
                  </ul>

                </div>
              </div>

            </div>
          </div>
          <hr>
          <div class="text-right">
            <button type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import { ModelSelect } from "vue-search-select";
import Mixin from '../../mixins/memberMixin'

export default {
  name: "addMemberDiary",
  components: {
    ModelSelect,
  },
  mixins: [Mixin],
  data: function () {
    return {
      loadingActive: false,
      itemsPT: [],
      optionsMember: [{ value: null, text: 'Please select' }],
      id_lead_member: null,
      id_lead: null,
      addData: {
        member_id: null,
        personal_trainer_id: null,
        current_body_weight: null,
        body_weight_change: null,
        body_weight_change_remarks: '',
        body_fat: null,
        body_muscle: null,
        visbody_photo: null,
        current_waist: null,
        change_waist: null,
        current_waist_remarks: '',
        progress_front_photo: '',
        progress_side_left_photo: '',
        progress_side_right_photo: '',
        progress_side_back_photo: '',
        strength_improvement: null,
        strength_improvement_remarks: '',
        carry_improvement: null,
        carry_improvement_remarks: '',
        conditioning_improvement: null,
        conditioning_improvement_remarks: '',
        movement_quality_improvement: null,
        movement_quality_improvement_remarks: '',
        confidence_in_training: null,
        confidence_in_training_remarks: '',
        protein_quality_intake: null,
        protein_quality_intake_remarks: '',
        hydration_consistency: null,
        hydration_consistency_remarks: '',
        meal_structure: null,
        meal_structure_remarks: '',
        appetite_management: null,
        appetite_management_remarks: '',
        weekend_control: null,
        weekend_control_remarks: '',
        overall_compliance: null,
        overall_compliance_remarks: '',
        sleep_quality: null,
        sleep_quality_remarks: '',
        stress_management: null,
        stress_management_remarks: '',
        daily_movement: null,
        daily_movement_remarks: '',
        routine_stability: null,
        routine_stability_remarks: '',
        mindset_and_accountability: null,
        mindset_and_accountability_remarks: '',
        consistency_level: null,
        consistency_level_remarks: '',
        confidence_level: null,
        confidence_level_remarks: '',
        response_to_setbacks: null,
        response_to_setbacks_remarks: '',
        standart_of_effort: null, // typo sesuai DB
        standart_of_effort_remarks: '',
        biggest_win: '',
        biggest_weakness: '',
        main_adjustment_needed: '',
        recommended_focus: '',
        fasting_blood_sugar: null,
        triglycerides: null,
        cholesterol: null,
        ldl: null,
        hdl: null,
        sgpt: null,
        additional_notes: ''
      },
      TIMEFRAME_EXPETATION: [],
      RATING_SCALE: [],
      MEAL_FREQUENCY: [],
      SNACKING_HABITS: [],
      WEEKEND_INTAKE: [],
      EATING_OUT_FREQ: [],
      WILLING_TO_TRACK: [],
      ORDINAL_SCALE: [],
      WORK_SCHEDULE: [],
      CONSISTENCY_LEVEL: [],
      ONE_CHOICES: [],
      visbodyPhotoPreview: null,
      visbodyPhotoPreview2: null,
      progressFrontPhotoPreview: null,
      progressSideLeftPhotoPreview: null,
      progressSideRightPhotoPreview: null,
      progressSideBackPhotoPreview: null
    };
  },
  methods: {
    visbodyImagePreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.visbodyPhotoPreview = e.target.result;

          // for upload not base64
          this.visbodyPhotoPreview2 = input.files[0];

          this.onUploadImage();
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    frontPhotoPreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          console.log(e.target.result)
          // for upload not base64
          this.progressFrontPhotoPreview = input.files[0];

          this.onUploadImageProgress(1);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    sideLeftPhotoPreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          console.log(e.target.result)
          // for upload not base64
          this.progressSideLeftPhotoPreview = input.files[0];

          this.onUploadImageProgress(2);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    sideRightPhotoPreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          console.log(e.target.result)
          // for upload not base64
          this.progressSideRightPhotoPreview = input.files[0];

          this.onUploadImageProgress(3);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    sideBackPhotoPreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          console.log(e.target.result)
          // for upload not base64
          this.progressSideBackPhotoPreview = input.files[0];

          this.onUploadImageProgress(4);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    openPage(event) {
      this.$router.push(event)
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // confirm
          this.$swal
            .fire({
              title: "Are you sure?",
              text: "You won't be able to revert this!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, save it!",
            })
            .then((result) => {
              if (result.value) {
                this.loadingActive = true
                axios.put("crm/v1/assessment/2to4weekschecking/" + this.$route.query.xid, this.addData)
                  .then((response) => {
                    console.log('response', response)
                    this.loadingActive = false
                    this.$swal.fire(
                      "Saved!",
                      "Data has been saved.",
                      "success"
                    );

                    this.reloadData();
                  }).catch(error => {
                    this.loadingActive = false
                    console.log('error', error)
                    this.$toast.success('cant saved data!', 'Error', {
                      position: 'topCenter',
                      icon: 'icon-envelope',
                      progressBarColor: 'rgb(0, 255, 184)',
                      theme: 'dark',
                      backgroundColor: '#565c70',
                      messageColor: '#fff'
                    })
                  })
              }
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff",
          });
        }
      });
    },
    onUploadImageProgress(event) {
      this.loadingActive = true
      const formDataS3 = new FormData();

      if (event == 1) {
        formDataS3.append("file", this.progressFrontPhotoPreview);
      } else if (event == 2) {
        formDataS3.append("file", this.progressSideLeftPhotoPreview);
      } else if (event == 3) {
        formDataS3.append("file", this.progressSideRightPhotoPreview);
      } else if (event == 4) {
        formDataS3.append("file", this.progressSideBackPhotoPreview);
      }

      formDataS3.append("prefix", `ASSESMENT-${this.$route.query.id}`);
      axios.post("https://digmsix.paradigmfitnessindonesia.com/s3/storage/upload", formDataS3)
        .then(resp => {
          console.log("Photo uploaded to s3", resp);
          let updateBody = {}

          if (event == 1) {
            updateBody = { progress_front_photo: resp.data.data.location }
          } else if (event == 2) {
            updateBody = { progress_side_left_photo: resp.data.data.location }
          } else if (event == 3) {
            updateBody = { progress_side_right_photo: resp.data.data.location }
          } else if (event == 4) {
            updateBody = { progress_side_back_photo: resp.data.data.location }
          }
          // update to db
          axios.put(`crm/v1/assessment/2to4weekschecking/${this.$route.query.xid}`, updateBody)
            .then(response => {
              this.loadingActive = false
              console.log("Photo updated", response);
              this.progressFrontPhotoPreview = null
              this.progressSideLeftPhotoPreview = null
              this.progressSideRightPhotoPreview = null
              this.progressSideBackPhotoPreview = null
              this.reloadData()
            }).catch(error => {
              console.error("Photo error", error);
            })
        }).catch(error => {
          this.loadingActive = false
          console.error("Photo error", error);
        })
    },
    // visbody
    onUploadImage() {
      this.loadingActive = true
      const formDataS3 = new FormData();
      formDataS3.append("file", this.visbodyPhotoPreview2);
      formDataS3.append("prefix", `ASSESMENT-${this.$route.query.id}`);
      axios.post("https://digmsix.paradigmfitnessindonesia.com/s3/storage/upload", formDataS3)
        .then(resp => {
          console.log("Photo uploaded to s3", resp);
          // update to db
          axios.put(`crm/v1/assessment/2to4weekschecking/${this.$route.query.xid}`, { visbody_photo: resp.data.data.location })
            .then(response => {
              this.loadingActive = false
              console.log("Photo updated", response);
              this.visbodyPhotoPreview2 = null
              this.reloadData()
            }).catch(error => {
              console.error("Photo error", error);
            })
        }).catch(error => {
          this.loadingActive = false
          console.error("Photo error", error);
        })
    },
    reloadData() {
      axios.get(`crm/v1/assessment/2to4weekschecking/${this.$route.query.xid}`).then((response) => {
        this.addData = response.data.data;
      })
    },
    fetchData() {
      axios.get(`crm/v1/assessment/2to4weekschecking/${this.$route.query.xid}`).then((response) => {
        this.addData = response.data.data;
      })

      axios.get("fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc").then((response) => {
        this.itemsPT = response.data.data.rows;
      })

      axios.get("crm/v1/assessment_category?page=&limit=").then((response) => {
        const data = response.data.data.rows;

        // filter timeframe expectation
        this.TIMEFRAME_EXPETATION = data.filter((item) => {
          return item.category_type == 'TIMEFRAME_EXPETATION';
        });

        // filter rating scale
        this.RATING_SCALE = data.filter((item) => {
          return item.category_type == 'RATING_SCALE';
        });

        // filter meal frequency
        this.MEAL_FREQUENCY = data.filter((item) => {
          return item.category_type == 'MEAL_FREQUENCY';
        });

        // filter snacking habits
        this.SNACKING_HABITS = data.filter((item) => {
          return item.category_type == 'SNACKING_HABITS';
        });

        // filter weekend intake
        this.WEEKEND_INTAKE = data.filter((item) => {
          return item.category_type == 'WEEKEND_INTAKE';
        });

        // filter eating out frequency
        this.EATING_OUT_FREQ = data.filter((item) => {
          return item.category_type == 'EATING_OUT_FREQ';
        });

        // filter willing to track
        this.WILLING_TO_TRACK = data.filter((item) => {
          return item.category_type == 'WILLING_TO_TRACK';
        });

        // filter ordinal scale
        this.ORDINAL_SCALE = data.filter((item) => {
          return item.category_type == 'ORDINAL_SCALE';
        });

        // filter work schedule
        this.WORK_SCHEDULE = data.filter((item) => {
          return item.category_type == 'WORK_SCHEDULE';
        });

        this.ONE_CHOICES = data.filter((item) => {
          return item.category_type == 'ONE_CHOICES';
        });

        // filter consistency level
        this.CONSISTENCY_LEVEL = data.filter((item) => {
          return item.category_type == 'CONSISTENCY_LEVEL';
        });
      })
    },
  },
  created() {
    this.fetchData();
    this.id_lead_member = this.$route.query.id;
    this.addData.member_id = this.$route.query.id;
    this.id_lead = this.$route.query.id_lead;
  },
};
</script>

<style>
.upload-container {
  max-width: 700px;
}

.upload-box {
  display: block;
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f9fafb;
}

.upload-box:hover {
  border-color: #64748b;
  background: #f1f5f9;
}

.upload-content .icon {
  font-size: 40px;
  color: #94a3b8;
  margin-bottom: 10px;
}

.upload-content h5 {
  font-weight: 600;
  margin-bottom: 5px;
}

.upload-content p {
  color: #64748b;
  margin: 0;
}

.note {
  display: block;
  margin-top: 10px;
  color: #6b7280;
}


.required {
  color: red;
}

.radio-group {
  display: flex;
  gap: 20px;
  margin-top: 15px;
}

.radio-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

/* hide default radio */
.radio-item input {
  display: none;
}

.circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #64748b;
  transition: all 0.3s ease;
}

/* selected */
.radio-item input:checked+.circle {
  background: linear-gradient(135deg, #4f6df5, #3b5bdb);
  color: white;
  border: none;
}

/* label text */
.radio-item small {
  margin-top: 8px;
  color: #64748b;
}

.nutrition-note {
  max-width: 900px;
  color: #374151;
  font-family: 'Segoe UI', sans-serif;
}

.title-main {
  letter-spacing: 1px;
}

.section {
  margin-top: 30px;
}

.section-title {
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 10px;
}

ol {
  padding-left: 20px;
  margin-bottom: 10px;
}

ol li {
  margin-bottom: 6px;
  letter-spacing: 0.5px;
}

.note {
  margin-top: 10px;
  color: #4b5563;
}

.card-custom {
  max-width: 800px;
  margin: auto;
  border-radius: 16px;
}

.section-title {
  font-weight: 700;
  letter-spacing: 1px;
}

.note {
  font-style: italic;
  color: #6c757d;
}
</style>
